import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const InfoCircle: IconDef = {
  svg: (
    <G>
      <Path
        d="M10 13.3333V9.99996M10 6.66663H10.0083M18.3333 9.99996C18.3333 14.6023 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6023 1.66667 9.99996C1.66667 5.39759 5.39763 1.66663 10 1.66663C14.6024 1.66663 18.3333 5.39759 18.3333 9.99996Z"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
      viewBox: '0 0 20 20',
    };
  },
};
